var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcExternalLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666564",
    fillRule: "evenodd",
    d: "M12.667 12V8c0-.368.298-.667.666-.667.369 0 .667.299.667.667v4c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2V4c0-1.103.897-2 2-2h4c.369 0 .667.299.667.667 0 .368-.298.666-.667.666H4c-.368 0-.667.3-.667.667v8c0 .367.299.667.667.667h8c.368 0 .667-.3.667-.667zm-.948-8.661l-1.056-.006c-.368-.002-.665-.302-.663-.67.002-.367.3-.663.667-.663h.003l2.665.013c.366.002.663.3.663.666L14 5.333c0 .368-.298.667-.666.667-.369 0-.667-.298-.667-.666V4.277L8.47 8.47c-.13.13-.3.196-.47.196-.172 0-.342-.066-.472-.196-.26-.26-.26-.682 0-.942l4.19-4.19z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcExternalLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_external_link.741baab2.svg";
export { ForwardRef as ReactComponent };